<template>
  <div class="program-grup">
    <cs-form ref="creatEditForm" labelWidth="90px"
    formWidth="40%" :form="form"
    :formData="formData"
    :rules="rules"
    :showMessage="false">
      <template slot="sndCategory">
        <el-select v-model="sndChoice" style="width:100%" multiple filterable placeholder="请选择" @change="changeSnd">
          <el-option
            v-for="item in sndCategoryList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </template>
      <template slot="seriesNo">
        <el-input-number v-model="form.seriesNo"  :min="1" label="描述文字"></el-input-number>
      </template>
      <template slot="dsc">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          maxlength="80"
          show-word-limit
          v-model="form.dsc">
        </el-input>
      </template>
      <template slot="poster">
        <el-upload
          class="upload-demo-poster"
          ref="upload"
          :action="postVideoUrl"
          name="videoImg"
          :on-preview="handlePreview"
          :http-request="upload"
          :on-success="uploadSuccess"
          :on-remove="uploadRemove"
          :on-exceed="handleExceed"
          :limit="1"
          :file-list="posterList"
          list-type="picture-card">
          <!-- <el-button size="small" type="primary">点击上传</el-button> -->
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，建议尺寸412*600</div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </template>
      <template slot="posterH">
        <el-upload
          class="upload-demo-posterH"
          ref="upload"
          :action="postVideoUrl"
          name="videoImg"
          :on-preview="handlePreview"
          :http-request="uploadw"
          :on-success="uploadSuccessw"
          :on-remove="uploadRemovew"
          :on-exceed="handleExceed"
          :limit="1"
          :file-list="posterHList"
          list-type="picture-card">
          <i class="el-icon-plus"></i>
          <!-- <el-button size="small" type="primary">点击上传</el-button> -->
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，建议尺寸528*296</div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </template>
      <template slot="submit">
        <el-button type="primary" style="width:80px" @click="handleSubmit">保 存</el-button>
      </template>
    </cs-form>
  </div>
</template>
<script>
import { uploadWImg, checkImg } from '@/resource/api/index'
export default {
  name: 'ProgramCatalogUGC',
  props: ['form', 'categoryList', 'formData', 'rules', 'sndCategoryList'],
  data () {
    return {
      sndChoice: [], // 二级分类的列表
      dialogImageUrl: '',
      dialogVisible: false,
      posterList: [], // 海报上传的列表
      posterHList: [] // 横海报上传的列表
    }
  },
  computed: {
    postVideoUrl: function () {
      return process.env.VUE_APP_BASE_API_MGR + '/videoImgPaths/upload'
    }
  },
  methods: {
    // 文件上传相关
    handlePreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //  纵向海报
    async upload (params) {
      const that = this
      await that.checkFile(params.file, 0, params)
    },
    // 横海报
    async uploadw (params) {
      const that = this
      await that.checkFile(params.file, 1, params)
    },
    // 文件上传前对文件的验证
    async checkFile (file, type, params) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isGt5M = file.size / 1024 / 1024 > 5
      if (!isJPG && !isPNG) {
        if (type == 1) {
          this.posterHList = []
        } else {
          this.posterList = []
        }
        this.$message.error('上传PNG/JPG 格式!')
        return false
      }
      if (isGt5M) {
        if (type == 1) {
          this.posterHList = []
        } else {
          this.posterList = []
        }
        this.$message.error('上传图片大小不能超过5M!')
        return false
      }
      var formData = new FormData()
      formData.append('imgFile', file)
      var that = this
      await checkImg(formData, type).then((res) => {
        if (res.code == 0) {
          that.$message({
            message: res.msg,
            type: 'error'
          })
          if (type == 1) {
            this.posterHList = []
          } else {
            this.posterList = []
          }
          return false
        } else if (res.code == 1) {
          const formData = new FormData()
          formData.append('videoImg', params.file)
          formData.append('username', that.$store.state.router.createBy)
          uploadWImg(formData).then((res) => {
            if (res.code == 1) {
              that.$message({
                message: '上传成功',
                type: 'success'
              })
              if (type == 0) {
                that.form.poster = res.result.imgPath
                this.hidePoster()
                this.$refs.creatEditForm.clearValidate('poster')
              } else {
                that.form.posterH = res.result.imgPath
                this.$refs.creatEditForm.clearValidate('posterH')
                this.hidePosterH()
              }
            } else {
              if (type == 1) {
                this.form.poster = null
              } else {
                this.form.poster = null
              }
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    uploadSuccess (response, file, fileList) {
      this.posterList = fileList
    },
    uploadSuccessw (response, file, fileList) {
      this.posterHList = fileList
    },
    uploadRemove (file, fileList) {
      this.posterList = []
      this.form.poster = ''
      const uploadBox = document.getElementsByClassName('el-upload--picture-card')
      uploadBox[0].style.display = 'inline-block'
    },
    uploadRemovew (file, fileList) {
      this.posterHList = []
      this.form.posterH = ''
      const uploadBox = document.getElementsByClassName('el-upload--picture-card')
      uploadBox[1].style.display = 'inline-block'
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    hidePoster () {
      const uploadBox = document.getElementsByClassName('el-upload--picture-card')
      uploadBox[0].style.display = 'none'
    },
    hidePosterH () {
      const uploadBox = document.getElementsByClassName('el-upload--picture-card')
      uploadBox[1].style.display = 'none'
    },
    posterShow () {
      this.posterList = [{
        url: this.form.poster,
        name: 'poster',
        id: this.form.poster
      }]
      this.hidePoster()
    },
    posterHShow () {
      this.posterHList = [{
        url: this.form.posterH,
        name: 'posterH',
        id: this.form.posterH
      }]
      this.hidePosterH()
    },
    handleSubmit () {
      this.$refs.creatEditForm.validate((valid) => {
        if (valid) {
          this.$emit('handleSubmit')
        }
      })
    },
    changeSnd () {
      this.$emit('changeSnd')
    }
  }
}
</script>
